import { render, staticRenderFns } from "./ColumnEditor.vue?vue&type=template&id=032fe558&scoped=true"
import script from "./ColumnEditor.vue?vue&type=script&lang=js"
export * from "./ColumnEditor.vue?vue&type=script&lang=js"
import style0 from "./ColumnEditor.vue?vue&type=style&index=0&id=032fe558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032fe558",
  null
  
)

export default component.exports